module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_6-b91a392c671d323c7ed15312f502069f.svg";